import type { SVGProps } from 'react';

const SvgAddUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.456 9.588h-1.203V8.412a.906.906 0 0 0-.9-.912.907.907 0 0 0-.898.912v1.176h-1.201a.906.906 0 0 0-.9.912c0 .502.404.911.9.911h1.2v1.177c0 .503.404.912.9.912s.899-.41.899-.912v-1.177h1.203c.495 0 .899-.41.899-.912a.907.907 0 0 0-.9-.911Z'
      fill='currentColor'
      opacity={0.4}
    />
    <path
      d='M9.855 15.016c-4.046 0-7.5.646-7.5 3.23s3.433 3.254 7.5 3.254c4.044 0 7.5-.647 7.5-3.231 0-2.584-3.434-3.253-7.5-3.253Z'
      fill='currentColor'
    />
    <path
      d='M9.855 12.554c2.754 0 4.962-2.236 4.962-5.026 0-2.79-2.208-5.028-4.962-5.028-2.755 0-4.963 2.238-4.963 5.028 0 2.79 2.208 5.026 4.963 5.026Z'
      fill='currentColor'
      opacity={0.4}
    />
  </svg>
);
export default SvgAddUser;
